import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import EchoLogo from "./EchoLogo";

const NAV_LINKS = [
  { label: "Confidentialité", href: "/politique", testid: "nav-privacy" },
  { label: "Conditions", href: "/conditions", testid: "nav-terms" },
  { label: "Support", href: "/support", testid: "nav-support" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome ? "glass-strong py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-2.5 group"
          aria-label="Echo — Accueil"
        >
          <EchoLogo size={36} testid="header-logo-icon" />
          <span className="text-white font-bold text-xl tracking-tight">Echo</span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              data-testid={link.testid}
              className="hidden sm:inline-flex px-3 py-2 text-sm text-white/60 hover:text-white transition-colors duration-300 font-medium"
            >
              {link.label}
            </Link>
          ))}
          <a
            href={isHome ? "#telecharger" : "/#telecharger"}
            data-testid="header-cta"
            className="ml-2 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-[#0B0514] text-sm font-semibold hover:bg-white/90 transition-all duration-300 hover:scale-[1.02]"
          >
            Télécharger
          </a>
        </nav>
      </div>
    </header>
  );
}
